export default __webpack_public_path__ + "static/media/3-pieces-upper-mantle.5f463de4.svg";